import {CancelIcon} from "./Icon/Cancel.icon.tsx";
import {FC} from "react";
import PortalPopup from "./PortalPopup.tsx";
import {Button} from "./Button.tsx";
import {LoadingIcon} from "./Icon/Loading.Icon.tsx";
import {noop} from "../utils.ts";

interface DeactivateUserModalProps {
    onClose: () => void
    title: string
    text: string
    onSubmit: () => void
    loading?: boolean
    cancelText?: string
    confirmText?: string
}
export const SimpleDialog: FC<DeactivateUserModalProps> = ({onClose, title, text, onSubmit, loading, cancelText, confirmText}) => {
    return <PortalPopup onOutsideClick={noop}>
        <div className="bg-white p-6">
            <div className="flex items-center justify-between p-2 m-2">
                <b className="text-xl font-bold">{title}</b>
                <div className="m-2 cursor-pointer" onClick={() => onClose()}>
                    <CancelIcon/>
                </div>
            </div>
            <div className="m-4">
                <p>{text}</p>
            </div>
            <div className="flex items-center justify-between">
                <Button onClick={onClose} name={cancelText ? cancelText : "Cancel"} primary={false} />
                <Button onClick={onSubmit} name={confirmText ? confirmText : "Confirm"} disabled={loading} icon={loading ? <LoadingIcon smallVariant={true} /> : null } primary={true} />
            </div>
        </div>
    </PortalPopup>
}